export { S as SingleSelectPillWrapper } from '../single-select-pill-wrapper/index-chunk.esm.js';
export { V as ViewRow } from '../view-row/index-chunk.esm.js';
export { S as Sticky } from '../sticky/index-chunk.esm.js';
import * as React from 'react';
import { classNames } from '@egds/react-core/utils';
import styles from '../styles/egds-search-experience-button-toggle-custom-content.css';
import styles$1 from '../styles/egds-search-experience-calendar-date-background.css';
export { E as ESSAdapter, G as GOOGLEMAPS_CATEGORY, c as GoogleAdapter, P as PlacesServiceStatus, b as ThirdPartyAdapter, a as ThirdPartyAdapterFactory, T as TypeaheadLocationType, h as appendQueryObject, e as appendQueryParam, f as filterTypeaheadResults, d as getSelectedResult, g as getSizeOfTypeaheadResults } from '../url-util/index-chunk.esm.js';
export { T as TypeaheadCustomTextInput } from '../typeahead-custom-text-input/index-chunk.esm.js';
import '@egds/react-core/pill';
import '@egds/react-core/icons';
import '../styles/egds-search-experience-single-select-pill-wrapper.css';
import '../styles/egds-search-experience-view-row.css';
import 'throttle-debounce';
import '../styles/egds-search-experience-sticky.css';
import '@shared-ui/localization-context';
import '@egds/react-core/field';
import '../styles/egds-search-experience-typeahead-custom-text-input.css';

const getClassNameList$1 = classNames.bind(styles);
const ButtonToggleCustomContent = (props) => {
    const { children, checked, className, disabled, id, name, onChange, ...attributes } = props;
    const baseClass = 'button-toggle-custom-content';
    const wrapperClassName = getClassNameList$1(baseClass, className, {
        [`${baseClass}-is-checked`]: checked,
        [`${baseClass}-is-disabled`]: disabled,
    });
    const containerClassName = getClassNameList$1(`${baseClass}-container`);
    const inputClassName = getClassNameList$1(`${baseClass}-input`, `is-visually-hidden`);
    return (React.createElement("div", { className: wrapperClassName },
        React.createElement("label", { className: containerClassName, htmlFor: id },
            React.createElement("input", { id: id, name: name, type: "checkbox", onChange: onChange, className: inputClassName, disabled: disabled, checked: checked, "aria-checked": checked, value: checked ? 'true' : 'false', ...attributes }),
            children)));
};
ButtonToggleCustomContent.displayName = 'ButtonToggleCustomContent';

const CalendarDateBackgroundThemesMap = [
    ['default', 'calendar-date-background-default'],
    ['positive', 'calendar-date-background-positive'],
    ['negative', 'calendar-date-background-negative'],
    ['neutral', 'calendar-date-background-neutral'],
];
const CalendarDateBackgroundThemes = new Map(CalendarDateBackgroundThemesMap);

const getClassNameList = classNames.bind(styles$1);
/**
 * CalendarDateBackground is used as a background layer within day cells.
 * It should stretch to fill the entire area of its cell, sitting on a layer below all other day template content.
 */
const CalendarDateBackground = (props) => {
    const { children, className, dataTestId, theme, backgroundShape } = props;
    const wrapperClassNames = getClassNameList('calendar-date-background', {
        'calendar-date-background-flat': theme === 'default' || backgroundShape === 'flat',
    }, {
        'calendar-date-background-rounded': backgroundShape === 'rounded',
    }, { 'calendar-date-background-circle': backgroundShape === 'circle' }, CalendarDateBackgroundThemes.get(theme), className);
    return (React.createElement("div", { className: wrapperClassNames, "data-test-id": dataTestId }, children));
};
CalendarDateBackground.displayName = 'CalendarDateBackground';

export { ButtonToggleCustomContent, CalendarDateBackground };
//# sourceMappingURL=index.esm.js.map
